import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import rules from "@/utils/pattern.js";
import { findTagById, saveTag, updateTag } from "@/service/structure.js";
export default {
  name: "position-add",
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    edit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    row: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "scroll",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      form: {
        tagName: "",
        tagCode: "",
        tagDescription: "",
        tagTarget: "ALL",
        tagValue: ""
      },
      detail: {},
      columns: [{
        // lg: 名称
        title: $t("eyrn2", "名称"),
        key: "tagName",
        rules: [
        // lg: 名称不能为空
        {
          required: true,
          message: $t("k93toz6", "名称不能为空")
        }, rules.positionName]
      }, {
        // lg: 代码
        title: $t("e2ri2", "代码"),
        key: "tagCode",
        disabled: false,
        rules: [rules.positionCode],
        renderForm: () => {
          // lg: 未填写，系统将自动生成
          return h("Input", {
            "attrs": {
              "disabled": this.edit,
              "placeholder": $t("suomylb", "未填写，系统将自动生成")
            }
          });
        }
      }, {
        // lg: 可使用成员范围
        title: $t("mchdu97", "可使用成员范围"),
        key: "tagTarget",
        titleForm: {
          truncate: 7,
          // lg: 可使用成员范围
          value: $t("mchdu97", "可使用成员范围")
        },
        renderForm: () => {
          // lg: 选择类型
          // lg: 部门
          // lg: 用户
          // lg: 全部
          return h("Select", {
            "attrs": {
              "placeholder": $t("il3ipc4", "选择类型"),
              "disabled": this.edit
            }
          }, [h("Option", {
            "attrs": {
              "value": "ORG"
            }
          }, [$t("pgxs2", "部门")]), h("Option", {
            "attrs": {
              "value": "USER"
            }
          }, [$t("kgsv2", "用户")]), h("Option", {
            "attrs": {
              "value": "ALL"
            }
          }, [$t("en402", "全部")])]);
        }
      }, {
        // lg: 描述介绍
        title: $t("d6o0mb4", "描述介绍"),
        key: "tagDescription",
        rules: [rules.tagDescription]
      }, {
        // lg:包含成员
        title: $t("atriq64", "包含成员"),
        showForm: () => {
          return this.edit;
        },
        renderForm: () => {
          return h("span", {
            "style": {
              color: "#000"
            }
          }, [this.detail.userNumber, $t("fju1", "人")]);
        }
      }, {
        // lg: 包含部门
        title: $t("atzuiu4", "包含部门"),
        showForm: () => {
          return this.edit;
        },
        renderForm: () => {
          return h("span", {
            "style": {
              color: "#000"
            }
          }, [this.detail.orgNumber, $t("ffu1", "个")]);
        }
      }]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.open();
      }
    }
  },
  methods: {
    close() {
      this.$refs["proForm"].reset();
      Object.keys(this.form).forEach(key => {
        this.form[key] = "";
      });
      this.form.tagTarget = "ALL";
      this.detail = {};
      this.loading = false;
      this.visible = false;
    },
    open() {
      if (this.edit) {
        this.columns[1].disabled = true;
        this.getDetail();
      } else {
        this.columns[1].disabled = false;
      }
    },
    async getDetail() {
      const params = {
        id: this.row.id
      };
      let {
        data
      } = await findTagById(params);
      if (data && data.result === 0) {
        this.detail = data.retVal;
        Object.keys(this.form).forEach(key => {
          this.form[key] = this.detail[key];
        });
      }
    },
    onSubmit() {
      this.$refs["proForm"].validate(async valid => {
        if (valid) {
          if (this.edit) {
            this.onSaveEdit();
          } else {
            this.onSaveAdd();
          }
        }
      });
    },
    async onSaveAdd() {
      const params = {
        ...this.form,
        tagValue: this.form.tagTarget
      };
      this.loading = true;
      let {
        data
      } = await saveTag(params);
      this.loading = false;
      if (data && data.result === 0) {
        // lg: 新增成功
        this.$Message.success($t("d76ha54", "新增成功"));
        this.$emit("onSuccess");
        this.close();
      }
    },
    async onSaveEdit() {
      const params = {
        id: this.row.id,
        tagName: this.form.tagName,
        tagDescription: this.form.tagDescription
      };
      this.loading = true;
      let {
        data
      } = await updateTag(params);
      this.loading = false;
      if (data && data.result === 0) {
        // lg: 修改成功
        this.$Message.success($t("ai8d7e4", "修改成功"));
        this.$emit("onSuccess");
        this.close();
      }
    }
  }
};